/**
 * @internal
 */
export class SkinData {

	name: string;
	slotArr: any[] = [];
}

